import { req, get, post } from '@/plugins/axios'
import type { res } from './login'
import { useSite2Station, useSource } from '@/store'
import { Site } from '@/common/const'
import { getCountryCurrency } from '@/util/useYan'
import { isAvailableAddition } from '@/composables/addition'

// 最近购买
export const lastCart = (): Promise<res> =>
  get('/order/cart/getCurrentCartList')

// 购物车分页
interface CRD {
  pageNum: number
  pageSize: number
  productSkuOrName?: string
  productType?: string
}
export const getCartRecords = (data: CRD): Promise<res> =>
  post('/order/cart/page', useSource(data))

// 购物车列表
export const getCartList = (params: { [key:string]:any }): Promise<res> => req('/order/cart/list', { ...params })

// 加入购物车
interface OD {
  productSku: string
  orderQuantity: number
  cartAdditionList?: {
    additionConfigId: number
    ingredientsSku?: string
    productSellPrice?: number
    livePriceFlag?: number
  }[]
}
interface ACD {
  commonProductItemList: OD[]
  addCartSource: number
  allIncludeFlag?:number
}
export const addCart = (data: ACD): Promise<res> =>
  post('/order/cart/add/commontProduct', data)

// 修改Sku数量
interface CSN {
  cartId: string
  orderQuantity: number
}
export const changeSkuNum = (data: CSN): Promise<res> =>
  post('/order/cart/update/sell/quantity', data)

// 修改customSku
export const changeMSku = (data: CSN): Promise<res> =>
  post('/order/cart/updateCustomerProductMsku', data)

// 变更Sku
interface RSD {
  cartId: string
  productSku: string
}
export const replaceSku = (data: RSD): Promise<res> =>
  post('/order/cart/replace', data)

// 添加附加项
interface AAD {
  cartId: string
  cartAdditionList: {
    additionConfigId: string
    ingredientsSku: string
    washedlabelAdditionId?: string
    washedlabelName?: string
    washedlabelSpecification?: string
  }[]
  noAdditionalFlag?: number
  shopProductSku?: string
  batch?: boolean
}
export const addAdt = (data: AAD): Promise<res> =>
  post('/order/cart/update/addition', data)

// 批量修改购物车附加项
export const batchEditShopcartAdApi = (data: any): Promise<res> =>
  post('/order/cart/batchUpdate/addition', data)

// 组合商品子商品附加项
export const addGpAdt = (data: AAD): Promise<res> =>
  post('/order/cart/update/combinationProductItemAddition', data)

// 删除Sku
interface POD {
  cartIdList: string[]
}
export const deleteSku = (data: POD): Promise<res> =>
  post('/order/cart/delete', data)

// 确认下单
export const previewOrder = (data: POD): Promise<res> =>
  req('/order/cart/confirm/order/list', { cartIdList: data.cartIdList + '' })

// 购物车下单
interface RCV {
  address: string
  city: string
  country: string
  district: string
  email: string
  postalCode: string
  province: string
  receiveName: string
  receiveTel: string
}
interface COD {
  cartIdList: string[]
  customerOrderNo?: string
  deliverAddress?: RCV
  deliveryAdditionalList?: {
    additionConfigId: number
    ingredientsSku: string
  }[]
  orderType: number
  priceFloatPercent: number
  remainCombinationProductItemList: {
    combinationProductSku: string
    remainCombinationQuantity: number
    shopProductSku: string
    systemOrderNo: string
  }[]
}
export const createOrder = (data: COD): Promise<res> =>
  post('/order/cart/create/order', data)

interface COPC {
  cartIds: string[]
  orderType: number
}
export const createOrderPreCheckApi = (data: COPC): Promise<res> =>
  post('/order/cart/createOrderPreCheck', data)

// 获取地区
interface AD {
  type: number
}
export const getArea = (data: AD): Promise<res> =>
  req('/settlement/area/getByType', data)

// 获取汇率
export const getExchange = (): Promise<res> => {
  return req('/settlement/exchangeRate/getLatestExchangeRate', {
    currencyCodeFrom: 'CNY',
    currencyCodeTo: getCountryCurrency(),
    stationCode: useSite2Station?.()
  })
}

/**
 * 未登录时获取汇率的接口
 * @param mainCustomerId
 * @returns
 */
export const getOriginExchangeRate = (stationCode: Site, currencyCode?: unknown): Promise<res> => {
  return req('/settlement/exchangeRate/getOriginExchangeRate', { stationCode, currencyCode })
}

// 浮动汇率
export const getFloatExchange = (mainCustomerId: unknown, currencyCode?: unknown): Promise<res> =>
  req('/settlement/exchangeRate/cnyToJpyExchangeRateAfterConfigFloat', { mainCustomerId, currencyCode, _t: Date.now() })

// 获取手续费
export const getServfee = (bizType: number): Promise<res> =>
  req('/settlement/customer/addition/getServiceCharge', { bizType })

// 创建或编辑组合商品
export const createGroup = async (data: any): Promise<res> => {
  return isAvailableAddition(data, () => post('/order/combination/product/createOrEdit', useSource(data)))
}

// 创建组合商品并加入到购物车
export const createGpAddCart = (data: any): Promise<res> => {
  return isAvailableAddition(data, () => post('/order/combination/product/createAndAddCart', useSource(data)))
}

// 购物车数量
export const getCartAmount = (): Promise<res> =>
  get('/order/cart/cartCommodityStatistics')

// 可组合的转结子商品
interface RGD {
  shopProductSkuList?: string[]
  ingredientsSkuList?: string[]
}
export const getRestGroupGoods = (data: RGD): Promise<res> =>
  post('/order/customer/platformOrderItem/remainCombinationList', data)

// 查询下单商品是否有未绑定的辅料
export const getRelIngt = (data: RGD): Promise<res> =>
  post('/order/customer/shop/ingredients/customer/relatedFlagList', data)

//
export const isFirstAdd = (): Promise<res> => get('/order/cart/checkFirstAddCat')

interface SIIS {
  productSkuList: string[]
}
// 验证是否在库
export const searchIsInStoreApi = (data: SIIS): Promise<res> =>
  post('/goods/search/isInStore', data.productSkuList)

// 是否显示不良品风险提示协议
export function defectiveProductRiskFlag (data?: any) {
  return get('/customer/defectiveProductRiskFlag', data)
}

/** 判断用户是否可以使用在途库存 */
export function canUseOnTheWayStockApi (data?: any) {
  return get('/order/cart/canUseOnTheWayStock', data)
}

// 更新不良品风险提示协议
export function updateProductRisk (data?: any) {
  return req('/customer/update/defectiveProductRiskFlag', data)
}

interface UEA {
  ossUrl: string
  taskType: number,
  /** 是否使用在途库存 */
  useOnTheWayStock?: boolean
}
// 表格上传订单，商品
export const uploadExcelApi = (data: any): Promise<res> =>
  post('/order/excel/submitTask', data)

interface SUPA {
  taskId?: string
  taskType: number
}
export const searchUploadProgressApi = (data: SUPA): Promise<res> =>
  post('/order/excel/queryTask', data)

interface OEKA {
  taskId: string
}
export const orderExcelKnowApi = (data: OEKA): Promise<res> =>
  post('/order/excel/know', data)

// 导出失败订单
export const downFailExcelApi = (params: OEKA): Promise<res> =>
  get('/order/excel/downloadExcel', {
    responseType: 'arraybuffer',
    params
  })

export const getCombineStockNumApi = (data: any): Promise<res> =>
  post('/order/cart/queryCombinationSubItemStock', data)

export const getCombinationServiceFreezeChargeApi = (data: any): Promise<res> =>
  get('/settlement/customer/addition/getCombinationServiceFreezeCharge', data)

export const updateShopCartAddressApi = (data: any): Promise<res> =>
  post('/order/customerReceivingAddress/save', data)

export const getShopcartAddressListApi = (data?: any): Promise<res> =>
  get('/order/customerReceivingAddress/list', data)

export const delShopcartAddressListApi = (data?: any): Promise<res> =>
  req('/order/customerReceivingAddress/deleteById', data)

// 购物车列表
export const getChoiceCartListApi = (params: { [key:string]:any }): Promise<res> => req('/order/cart/listAllInclude', { ...params })

// 一价全包购物车算价
export const calculatePriceAllIncludeApi = (data: any): Promise<res> =>
  post('/order/cart/calculatePriceAllInclude', data)

// 一价全包获取空运海运对应的物流id
export const getShipIdApi = (data: any): Promise<res> =>
  post('/settlement/intShipConfig/getAllIncludeShip', data)

// 更新购物车信息
export const updateShopcartApi = (data?: any): Promise<res> =>
  post('/goods/product/batchUpdateProduct', data)

export const getWhiteStockJpApi = (data?: any): Promise<res> =>
  get('/wms/base/config/grayOverseasInvCheck', data)
